export default {
  SAVE: "price_1LITsTBNojRG2LLA6zbH2EkE",
  AD_HOC: "price_1LITsXBNojRG2LLA8Mf2qxZI",
  LEGAL_REDRESS: "price_1LITsLBNojRG2LLAUxu8RBcI",
  CONCILIATION: "price_1LITsbBNojRG2LLA49RMz5ws",
  JUDICIAL_LIQUIDATION: "price_1LITsQBNojRG2LLA4wvMLQso",
  AMICAL_SETTLEMENT: "price_1LITrfBNojRG2LLAG2LJi9Di",
  ALL: "price_1LITsGBNojRG2LLAjMAWYBAw",
}